<!-- Pug Template -->
<template lang="pug">
.tech-company-vertical(
	:key="vertical.id"
)
	.tech-company-vertical-heading.card.card--heading.p-4.align-items-start.text-white.mb-4.fade-down(
		:style="headerStyle"
		data-in-view
	)
		.mx-n3.mb-3.align-self-stretch
			.scroll-x.pb-2
				.d-flex.px-3
					router-link.btn.btn-icon.flex-shrink-0.btn-pill.btn-white.btn-outline.font-sans.btn-lg.text-center(
						:to="backButton"
					)
						span.mdi.mdi-arrow-left
					.btn.btn-lg.btn-outline.btn-white.btn-pill.breadcrumb.ml-2.mr-3
						router-link.text-white.font-sans(
							:to="{name: 'index'}"
						) All Stages
						span.mdi.mdi-chevron-right.mx-1

						router-link.text-white.font-sans(
							:to="{name: 'stage', params: {stage_slug: stage.slug}}"
						) 0{{ stage.number }}. {{ stage.name }}
						span.mdi.mdi-chevron-right.mx-1

						template(
							v-if="parent"
						)
							router-link.text-white.font-sans(
								:to="{name: 'vertical', params: {vertical_slug: parent.slug}}"
							) {{ parent.name }}
							span.mdi.mdi-chevron-right.mx-1

						router-link.text-white.font-sans(
							:to="{path: `/vertical/${slug}`}"
						) {{ vertical.name }}

		.row.align-items-center.mx-n4
			.col-12.col-lg-auto.px-4
				h1.display-4.text-white.mb-0 {{ vertical.name }}
			.col-12.col-lg.px-4.border-left
				.demargin.description.card-text(
					style="max-width: 50em"
					v-html="replaceVerticalText(vertical.description, children)"
				)
		
		ul.my-2.list-unstyled.mx-n2(
			v-if="children.length"
		)
			li.d-inline-block.mx-2.my-1(
				v-for="child in children"
			)
				.custom-control.custom-radio
					input.custom-control-input(
						type="checkbox" 
						:id="`vertical-checkbox-${child.id}`"
						:value="child.id"
						v-model="selected"
					)
					label.custom-control-label(
						:for="`vertical-checkbox-${child.id}`"
					) {{ child.name }}

	.tech-company-vertical-companies.row(
		ref="listings"
	)


</template>

<!-- Script -->
<script>
import store from './store';
import {replaceVerticalText} from './store';
const $ = jQuery;
export default {
	props: {
		vertical_slug: {
			type: String,
			required: true
		}
	},

	data(){
		return {
			boxes: $('.tech-company-boxes').first(),
			selected: [],
			replaceVerticalText
		}
	},

	computed: {
		vertical(){
			return store.vertical(this.vertical_slug);
		},
		stage(){
			return this.vertical.stage;
		},
		headerStyle(){
			return {
				backgroundColor: this.stage.backgroundColor
			}
		},
		parent(){
			return this.vertical.parent ? store.verticalById(this.vertical.parent) : null;
		},
		children(){
			return this.stage.verticals.filter( v => v.parent == this.vertical.id );
		},
		slug(){
			if( this.parent ){
				return this.parent.slug + '/' + this.vertical.slug;
			}
			return this.vertical.slug;
		},
		backButton(){
			if( this.parent ){
				return {name: 'vertical', params:{ vertical_slug: this.parent.slug }};
			}
			return {name: 'stage', params:{ stage_slug: this.stage.slug }};
		},
		posts(){
			if( this.parent ){
				return this.vertical.posts;
			}
			return this.children.reduce( (p, child) => {
				p.push( ...child.posts );
				return p;
			}, [])
		}
	},

	watch: {
		selected(){
			this.updateBoxes();
			this.$emit('refreshInView');
		}
	},

	mounted(){
		this.updateBoxes();
	},

	updated(){
		this.updateBoxes();
	},

	methods: {
		updateBoxes(){
			this.$refs.listings.innerHTML = '';
			this.boxes.find('[data-id]').each( (i, el) => {
				let posts = this.posts;
				if( this.selected.length ){
					posts = this.selected.reduce( (items, id) => {
						items.push( ...store.verticalById(id).posts );
						return items;
					}, []);
				}
				const show = posts.includes( Number($(el).data('id')) );
				if( show ){
					const $clone = $(el).clone();
					$clone.appendTo( this.$refs.listings );
					const permalink = $(el).data('permalink');
					$clone.find('.excerpt-box')
						.attr('data-in-view', true)
						.wrap(`<a href="${permalink}">`)
					
				}
			});
			this.$emit('refreshInView');
		}
	}
};
</script>

<!-- SCSS Style -->
<style lang="scss" scoped>
.breadcrumb {

	white-space: nowrap;

	&:hover {
		background: transparent;
		color: inherit !important;
	}

	> * {
		white-space: nowrap;
	}

	a {
		font-weight: 600;
		&:hover {
			text-decoration: underline;
		}
	}
}

.border-left {
	@media (max-width: 991px){
		border-left-width: 0;
	}
}

.scroll-x {
	overflow-x: auto;
	scroll-behavior: smooth;
	&::-webkit-scrollbar { width: 0 !important }
}


.custom-control-label::before {
	background-color: transparent;
	border-color: #fff;
}

.custom-control-input:focus ~ .custom-control-label::before {
	border-color: #fff;
	box-shadow: 0 0 0 0.2rem rgb(255 255 255 / 25%);
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
	background-color: #fff;;
	border-color: #fff;
	
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='currentColor' d='M9,20.42L2.79,14.21L5.62,11.38L9,14.77L18.88,4.88L21.71,7.71L9,20.42Z' /%3E%3C/svg%3E");
	background-size: 0.75em 0.75em;
}

.card-text::v-deep a {
	color: #fff;
	text-decoration: underline;
	font-weight: bold;
}
</style>